// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UxNm","controls":"styles_controls__28HyH","charLimit":"styles_charLimit__1J8mk","input":"styles_input__2IHdi","send":"styles_send__3RLxV"};